import ComingSoonCop from "components/ComingSoonCop";
import ParentScrollView from "components/ParentScrollView";

export default function Men() {
    return (
        <ParentScrollView>
            <ComingSoonCop type="MEN"></ComingSoonCop>
        </ParentScrollView>
    );
}
